/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_BROKERAGE_SSO,
  RECEIVED_BROKERAGE_MFE,
  RECIEVED_BROKERAGE_MFE_LOGIN,
  RESET_BROKERAGE_MFE,
  UPDATE_BROKERAGE_MFE_STATE,
  RECEIVED_FIXED_INCOME_SSO
} from "./BrokerageActions";
import {MFE_STATE} from "support/BrokerageMFEUtils";

export const brokerageReducer = (state = {}, action) => {
  if (action.type === RECEIVED_BROKERAGE_SSO) {
    return {
      ...state,
      sso: action.ssoResponse
    };
  }
  if (action.type === RECEIVED_FIXED_INCOME_SSO) {
    return {
      ...state,
      fixedIncomeSso: action.ssoResponse
    };
  }
  if (action.type === RECEIVED_BROKERAGE_MFE) {
    return {
      ...state,
      brokerageMFE: action.mfeResponse?.jws
    };
  }
  if (action.type === RECIEVED_BROKERAGE_MFE_LOGIN) {
    return {
      ...state,
      brokerageMFELogin: true
    };
  }
  if(action.type === UPDATE_BROKERAGE_MFE_STATE) {
    return {
      ...state,
      brokerageMFEState: action.payload
    };
  }
  if(action.type === RESET_BROKERAGE_MFE) {
    return {
      ...state,
      brokerageMFELogin: false,
      brokerageMFEState: MFE_STATE.LOADING
    };
  }
  return state;
};
